const AddressLocationType = Object.freeze({
    VIRTUAL: 1,
    IN_PERSON: 2,
    HYBRID: 3,
});

export default AddressLocationType;